<template>
  <div class="page">
    <div class="topFixed" :class="!isShowTopFixed ? 'topFixedHide' : ''">
      <span class="logoImg" :class="hideScale.includes('logoImg') ? 'hideSclan' : ''"></span>
      <img class="logotext" src="@/image/nqy/logoTxt.png" alt="" :class="hideScale.includes('logotext') ? 'hideSclan' : ''">
      <img class="logoText" src="@/image/nqy/logoText.png" alt="" :class="hideScale.includes('logoText') ? 'hideSclan' : ''">
      <div class="tabListOut" :class="hideScale.includes('tabListOut') ? 'tabListOutfix' : ''">
        <div v-for="(item, index) in tabBtn.tabList" :key="index" :class="tabBtn.tabIndex == index ? 'btnActive' : ''" @click="tabClick(index)">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="mainInfo">
      <img src="@/image/nqy/top.png" class="imgboxData" alt="">
      <div class="videoDiv" v-show="tabBtn.tabIndex == 0">
        <video src="@/image/nqy/ad.mp4" controls autoplay loop muted></video>
      </div>
      <img src="@/image/nqy/1.png" class="imgboxData" v-show="tabBtn.tabIndex == 0" alt="" @click="show = true">
      <img src="@/image/nqy/2.png" class="imgboxData" v-show="tabBtn.tabIndex == 1" alt="" @click="show = true">
      <img src="@/image/nqy/3.png" class="imgboxData" v-show="tabBtn.tabIndex == 2" alt="" @click="show = true">
      <img src="@/image/nqy/_3.png" class="imgboxData" v-show="tabBtn.tabIndex == 3" alt="" @click="show = true">
      <img src="@/image/nqy/bot.png" class="imgboxData" alt="">
    </div>
    <div class="botinfo">
      <img src="@/image/nqy/textData.png" class="topTxt" alt="">
      <img src="@/image/nqy/1738905805379_B8B8942F-7995-4fe2-BC40-1DF5362D5473.png" class="qrcode" alt="">
    </div>
    <div class="popupOut" @touchmove.stop.prevent="touchmovestop" v-if="popupDataobj.isShow && popupDataobj.popupdata.length">
      <div class="popupMain">
        <i class="topleft"></i>
        <i class="escIcon" @click="closePopup"></i>
        <div class="mainData">
          <div>
            <span class="leftLine"></span>
          </div>
          <div class="rightView">
            <div class="boxes" v-for="(item, index) in popupDataobj.popupdata" :key="index" @click="popupClick(item.tit)">{{item.nameNew || item.tit}}</div>
          </div>
        </div>
      </div>
    </div>
    <van-image-preview v-model="show" :images="images" :maxZoom="8" class="previewsty">
      <template v-slot:index></template>
    </van-image-preview>
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, ImagePreview } from 'vant';
import { Shares } from '@/js/share'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      isShowTopFixed: true,
      sctimer: null,
      sctopInfo: {
        sctop: 0,
        lastSctop: 0,
        distance: 80,
      },
      hideScale: '',
      tabBtn: {
        tabIndex: 0,
        tabList: [
          {name: '产品介绍',},
          {name: '知识分享',},
          {name: '使用效果',},
          {name: '产品服务',},
        ]
      },
      popupDataobj: {
        isShow: false,
        popupdata: [],
        '社会稳定风险防控治理体系' : [
          {tit: '“五盾”维稳防控工程', nameNew: '社会维稳“五盾”风险防控工程'},
          {tit: '重大决策社会稳定风险评估系统', },
          {tit: '社会维稳信息管理平台', },
        ],
        '智慧养老助残服务' : [
          {tit: '社区居家养老服务服务平台'},
          {tit: '养老机构数字化管理平台', },
          {tit: '智慧助残服务管理平台', },
        ]
      },
      show: false,
      images: [require('@/image/nqy/1.png')]
    }
  },
  watch: {
    'tabBtn.tabIndex'(val) {
      let img = null
      switch (val) {
        case 0:
          img = require('@/image/nqy/1.png')
          break;
        case 1:
          img = require('@/image/nqy/2.png')
          break;
        case 2:
          img = require('@/image/nqy/3.png')
          break;
        case 3:
          img = require('@/image/nqy/_3.png')
          break;
        default:
          img = require('@/image/nqy/1.png')
              break;
      }
      this.images = [img]
    },
    'popupDataobj.isShow'(val) {
      !val ? this.$set(this.popupDataobj, 'popupdata' , []) : ''
    },
    'sctopInfo.sctop'(val) {
      clearTimeout(this.sctimer)
      console.log(val)
      if(!val) {
        this.hideScale = ''
      }
      if(val>338) {
        this.hideScale = 'tabListOut'
      }else{
        this.hideScale = ''
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollSet);

    let imgurl = 'https://xztys.goldweb.cn/img/shareImg.jpg'
    let title = '怎么才能让血脂水平正常？'
    let desc = '翅果油复合粉作为特殊膳食，可以帮助机体调节新陈代谢，尤其是脂类代谢。对于降低血脂有极好的的效果。'
    let link = 'http://xztys.goldweb.cn/#/nqyindex'
    // console.log(imgurl, title, desc, link)
    Shares.shareCode(imgurl, title, desc, link, (status,data) => {
      if(status === 'success') {
        console.log('success')// 分享成功的操作
      } else if(status === 'cancel') {
        console.log('error')// 分享失败的操作
      }
    })
  },
  methods: {
    touchmovestop() {},
    clickStop() {},
    closePopup() {
      this.$set(this.popupDataobj, 'isShow' , false)
    },
    popupData(eventData) {
      const setArr = this.popupDataobj[eventData]
      this.$set(this.popupDataobj, 'popupdata' , [...setArr])
      this.$set(this.popupDataobj, 'isShow' , true)
    },
    popupClick(item) {
      this.navigator({name: 'detail', query: {title: item}})
    },
    tabClick(index) {
      this.$set(this.tabBtn, 'tabIndex', index)
    },
    scrollSet() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.$set(this.sctopInfo, 'sctop', scrollTop)
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollSet)
  }
};
</script>

<style lang="less" scoped>
.page{
  width: 375px;
  min-height: 100vh;
  box-sizing: border-box;
  //padding-top: 199px;
  background: url("~@/image/nqy/pageBg.png");
  background-color: #e8dcc9;
  background-size: 100% auto;
  background-attachment: fixed;
  position: relative;
  .topFixed{
    width: 100%;
    height: 355px;
    //position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    transition: all .1s ease;
    //background: #00002020;
    opacity: 1;
    overflow: hidden;
    .logoImg{
      width: 105px;
      height: 92px;
      background: url("~@/image/nqy/nqyLogo.png") no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
      display: block;
      margin: 0 auto;
      margin-top: 32px;
      margin-bottom: 27px;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
    }
    .logotext{
      width: 309.5px;
      height: 102.5px;
      display: block;
      margin: 0 auto;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
    }
    .logoText{
      width: 150.5px;
      height: 24px;
      display: block;
      margin: 0 auto;
      margin-top: 15px;
      margin-bottom: 36px;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
    }
    .tabListOut{
      width: 100%;
      padding: 0 6px;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 77px 77px 92px 77px;
      grid-template-rows: 25px;
      grid-gap: 8px;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
      justify-content: center;
      position: relative;
      top: 0;
      >div{
        font-family: MicrosoftYaHei;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        //background-size: 100% 100%;
        //background-image: url("~@/image/btnBg.png");
        background-repeat: no-repeat;
        background-position: -77px bottom;
        background-size: 77px 6px;
        background-image: url("~@/image/nqy/tabBtnBg.png");
        //&:hover{
        //  background-size: 100% 100%;
        //  background-image: url("~@/image/btnHover.png");
        //}
      }
      .btnActive{
        //background-size: 100% 100%;
        //background-image: url("~@/image/btnHover.png");
        background-size: 77px 6px;
        background-image: url("~@/image/nqy/tabBtnBg.png");
        background-position: center bottom;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #000000;
        transition: all .2s ease;
      }
    }
    .tabListOutfix{
      position: fixed;
      top: 0;
      width: 100%;
      transition: all .1s ease;
      background: transparent;
      height: 48px;
      align-content: center;
      justify-content: center;
      backdrop-filter: blur(1.8px);
    }
    .hideSclan{
      opacity: 0;
      height: 0;
      z-index: -1;
      transition: all .5s ease;
    }
  }
  .topFixedHide{
    //opacity: 0;
    //height: 0;
    //background: transparent;
  }
  .mainInfo{
    .videoDiv{
      width: 82.28%;
      display: block;
      margin: 0 auto;
      border: 8px solid #ccaa88;
      background: #fffff6;
      border-top: none;
      border-bottom: none;
      box-sizing: border-box;
      video{
        width: 90%;
        margin: 0 auto;
        display: block;
      }
    }
    .imgboxData{
      width: 90%;
      display: block;
      margin: 0 auto;
    }
  }
  .botinfo{
    width: 100%;
    min-height: 147px;
    overflow: hidden;
    .topTxt{
      width: 342px;
      display: block;
      margin: 0 auto;
      //margin-bottom: 30px;
    }
    .qrcode{
      display: block;
      width: 118px;
      height: 118px;
      margin: 0 auto;
      margin-bottom: 30px;
    }
  }
}
//.previewsty ::v-deep .van-image-preview__image--vertical{
//  transform: scale(2, 2) translate(0px, 0px);
//}
</style>
